import chamados_api from "./chamados_api";
import { APP_NAME, APP_VERSION, detectarPlataformaWeb } from "@/config/appInfo";

type ClienteTelemetria = {
  _id?: string;
  id_conta?: string;
  login?: string;
  nome?: string;
};

// Envia um evento de login para o Painel de Dados do InovaSupport.
// À prova de falha: nunca lança nem atrapalha o fluxo do usuário.
export async function enviarTelemetriaLogin(u: ClienteTelemetria): Promise<void> {
  try {
    await chamados_api.post("/telemetry/event", {
      id_conta: u.id_conta,
      id_usuario: u._id,
      login: u.login,
      nome: u.nome,
      app: APP_NAME,
      eventType: "login",
      appVersao: APP_VERSION,
      plataforma: detectarPlataformaWeb(),
    });
  } catch {
    // silencioso de propósito
  }
}
